import axios from 'axios'
import {
  get,
  post,
  del,
  getfile
} from '@/http/request'
import {
  HOST
} from '@/http/config'

// 基础信息安保人员列表
export function getSecuritylist(params) {
  return get(`${HOST}basis-security/list`, params)
}
// 根据id删除
export function delSecurity(params) {
  return del(`${HOST}basis-security/delete`, params)
}
// 详情
export function getSecurityDetails(params) {
  return get(`${HOST}basis-security/get`, params)
}
// 新增
export function saveSecurity(params) {
  return post(`${HOST}basis-security/save`, params)
}
// 修改
export function updateSecurity(params) {
  return post(`${HOST}basis-security/update`, params)
}
//历史修改版本列表
export function getHistoryList(params) {
  return get(`${HOST}basis-security-history/list`, params)
}
// 历史修改版本详情
export function getHistoryDetial(params) {
  return get(`${HOST}basis-security-history/get`, params)
}
// 导出
export function Export(params) {
  return getfile(`${HOST}basis-security/export`, params)
}



// WEBPACK FOOTER //
// ./src/views/baseInfoManagement/securityInfo/api.js